import React from 'react';
import { any } from 'prop-types';
import { parseString } from '@helpers';
import style from './NewTable.module.scss';

const mapping = {
  table: 'td',
  table_rows_headers: 'th',
  new_table_body: 'td', // ✅ Add this line
};

const renderTableRows = (rows, rowsType) => {
  const CurrentTag = mapping[rowsType];

  if (!CurrentTag) {
    console.error(`Unknown row type: ${rowsType}`);
    return null;
  }

  if (!rows || !rows.length) return null;

  if (rowsType === 'table_rows_headers') {
    const headerCells = rows.map((item, index) => (
      <CurrentTag
        className={style.tableCell}
        style={{ width: 100 / rows.length + '%' }}
        key={`header-${index}`}
      >
        {parseString(item.header_col?.richText)}
      </CurrentTag>
    ));
    return <tr className={style.tableRow}>{headerCells}</tr>;
  }

  // console.log('rows: ', rows);
  return rows.map((row, rowIndex) => {
    const cols = [];

    for (let i = 1; i <= 7; i++) {
      const richText = row[`col${i}`]?.richText;
      const image = row[`col${i}_image`];

      cols.push(
        <CurrentTag
          style={{ width: 100 / rows.length + '%' }}
          key={`row-${rowIndex}-col${i}`}
        >
          {i > 4 ? (
            <div className={style.cellContent}>
              {image?.url && (
                <img
                  src={image.url}
                  alt={image.alt || ''}
                  className={style.cellImage}
                />
              )}
              {richText && parseString(richText)}
            </div>
          ) : (
            <div className={style.nonWrap}>
              {image?.url && (
                <img
                  src={image.url}
                  alt={image.alt || ''}
                  className={style.cellImage}
                />
              )}
              {richText && parseString(richText)}
            </div>
          )}
        </CurrentTag>
      );
    }

    return (
      <tr className={style.tableRow} key={`row-${rowIndex}`}>
        {cols}
      </tr>
    );
  });
};

const NewTable = ({ section }) => {
  console.log('section: ', section);
  if (!section || !section.length) return null;

  const headerSlice = section.find((slice) => slice.slice_type === 'new_table');
  const bodySlice = section.find(
    (slice) => slice.slice_type === 'new_table_body'
  );

  const tableColsHeaders = headerSlice?.items || [];
  const tableRows = bodySlice?.items || [];

  return (
    <div className={style.Table}>
      <div className={style.container}>
        <div className={style.tableWrapper}>
          <table className={style.subprocessorsTable}>
            {tableColsHeaders.length > 0 && (
              <thead>
                {renderTableRows(tableColsHeaders, 'table_rows_headers')}
              </thead>
            )}
            {tableRows.length > 0 && (
              <tbody>{renderTableRows(tableRows, 'new_table_body')}</tbody>
            )}
          </table>
        </div>
      </div>
    </div>
  );
};

NewTable.propTypes = {
  section: any,
};

export default NewTable;
